import { ReactNode } from 'react';
import { Logo } from '../../assets';
import { cx } from '@/utils/cx';

interface SignUpLayoutProps {
    children: ReactNode;
}

export function SignUpLayout({ children }: SignUpLayoutProps) {
    return (
        <div className='flex flex-col min-h-screen gap-4 items-center bg-[#EFF1F7]'>
            
            <div className="flex w-full p-4 h-[100vh] overflow-y-auto">
                    {children}
            </div>
        </div>

    );
}